import { t, type Lang, type TabId } from '../core/index.js';
import type { TabItem } from './components/index.js';

/** The four sections of a paired machine (tab bar); the ids are also the address hashes (core/screens/frame.ts). */
export type { TabId };

export function tabItems(lang: Lang): TabItem<TabId>[] {
  return [
    { id: 'maschine', label: t(lang, 'tabMachine'), icon: 'machine' },
    { id: 'bezug', label: t(lang, 'tabBrew'), icon: 'cup' },
    { id: 'einstellungen', label: t(lang, 'tabSettings'), icon: 'sliders' },
    { id: 'wartung', label: t(lang, 'tabCare'), icon: 'wrench' },
  ];
}
